import React from 'react';
import tickIcon from "assets/siteIntro/landingPage/icons/tickIcon.svg"
import { Link } from 'react-router-dom';
import { WALLET } from 'shared/router';
import { planDetails } from 'utils/constant/siteIntro/landingPage';
import { LazyImage } from 'components/image';


const Index = () => {




    return (
        <div className="flex items-center justify-center">
            <div className="w-full px-4 py-24">
                <div className="flex flex-col items-center text-black">
                    <div className='font-semibold text-2xl sm:text-3xl md:text-[40px] mt-10 text-center'>Ready To get Start ?</div>
                    {/* <div className="mt-2">14 days unlimited free trial. No contract or credit card required.</div> */}

                    <div className="flex flex-wrap justify-center gap-5 mt-10 mb-20 ">
                        {planDetails?.map((item, index) => (
                            <div key={index} className={`w-[350px]  p-4 ${item?.cardBg} flex flex-col items-start ${item?.textColor} rounded-xl shadow-lg border`}>

                                <div className="flex items-center justify-between w-full">

                                    <div>
                                        <div className="text-xl font-semibold">{item?.mainText}</div>
                                        <div className="flex items-center mt-3 mb-4 space-y-2">
                                            <p className="text-4xl font-bold">₹{item?.actualPrice} <span className='text-lg'>/ {item?.duration}</span></p>
                                        </div>
                                    </div>

                                    <LazyImage src={item?.sideImage} className='w-[50%] h-fit flex items-end justify-end' alt="plan label" />

                                </div>

                                <div className='my-6'>
                                    {item?.items?.map((features, index) => (
                                        <div key={index} className="flex justify-start w-full mb-2">
                                            <LazyImage src={tickIcon} className='rounded-full' />
                                            <p className="ml-2">{features}</p>
                                        </div>
                                    ))}
                                </div>

                                <div className="flex justify-center w-full mt-auto mb-5">
                                    <Link to={WALLET.PLANES} className={`${item?.btnBg} ${item?.btnBg === 'bg-white' ? 'text-black' : 'text-white'} w-[90%] py-2 rounded-md mb-4 text-center cursor-pointer`}>
                                        Buy
                                    </Link>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>


    );
};

export default React.memo(Index);